import { Component, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';

@Component({
    selector: 'move-btn',
    templateUrl: './move-btn.component.html',
    styleUrls: ['./move-btn.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule]
})
export class MoveBtnComponent {

    active: boolean = false;

    constructor(private element: ElementRef,
                protected r: Renderer2
    ) {

    } 

    getEl(): HTMLElement {

        return this.element.nativeElement;

    }

    @HostListener('mouseenter')
    onMouseEnter() {

        this.r.addClass(this.element.nativeElement.querySelector(':scope .move-account'), 'move-account-hover');
        this.r.addClass(this.element.nativeElement.querySelector(':scope >div'), 'hovered');

    }

    @HostListener('mouseleave')
    onMouseLeave() {

        this.r.removeClass(this.element.nativeElement.querySelector(':scope .move-account'), 'move-account-hover');
        this.r.removeClass(this.element.nativeElement.querySelector(':scope >div'), 'hovered');

    }

    public setActive(active: boolean): void {

        this.active = active;

        if (this.active) {

            this.r.addClass(this.element.nativeElement.querySelector(':scope .move-account'), 'move-account-active');
            this.r.addClass(this.element.nativeElement.querySelector(':scope >div'), 'active');

        }
        else {

            this.r.removeClass(this.element.nativeElement.querySelector(':scope .move-account'), 'move-account-active');
            this.r.removeClass(this.element.nativeElement.querySelector(':scope >div'), 'active');

        }

    }

    public isActive(): boolean {

        return this.active;

    }



}
